<template>
    <div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''" style="padding-top: 72px">
        <head-nav @userInfo="getUserToken"></head-nav>
        <img :src="imgAllPath('banner.png')" alt class="banner" />
        <div class="download_sdk">
            <div class="electronic_content sdk">
                <el-button type="primary" @click="downLoadSdk">电子凭证利用SDK下载</el-button>
                <ul>
                    <li v-for="(item, index) in sdkList" :key="index">
                        <span></span>
                        {{ item }}
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="electronic_container">
            <h2>电子凭证的利用</h2>
            <div class="electronic_content pzly">
                <div class="item" v-for="(item, index) in pzlyList" :key="index">
                    <img :src="imgAllPath(item.img)" alt />
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div> -->
        <a id="public" name="public" class="zhanwei"></a>
        <electronicDec :token="token"></electronicDec>
        <div class="electronic_container fwzc_container">
            <h2>覆盖凭证全场景的服务支持</h2>
            <div class="electronic_content fwzc">
                <div class="left">
                    <swiper ref="mySwiper" :options="swiperOptions">
                        <swiper-slide class="swiper-slide"
                            v-for="(item, index) in ['fwzc_01.png', 'fwzc_02.png', 'fwzc_03.png', 'fwzc_05.png', 'fwzc_04.png', 'fwzc_06.png']"
                            :key="index">
                            <img :src="imgAllPath(item)" alt />
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="right">
                    <ul class="pagination">
                        <li v-for="(item, index) in fwzcList" :key="index" :class="{ active: realIndex == index }"
                            @click="chooseIndex(index)">
                            <div class="name"><span>0{{ index + 1 }}</span>{{ item.name }}</div>
                            <div class="num">0{{ index + 1 }}</div>
                            <div class="hover_content">
                                <h2>{{ item.name }}</h2>
                                <p>{{ item.content }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="electronic_container">
            <h2>OFD电子凭证特性</h2>
            <div class="electronic_content pzly pztx">
                <div class="item" v-for="(item, index) in pztxList" :key="index">
                    <img :src="imgAllPath(item.img)" alt />
                    <div class="left">
                        <h3>{{ item.name }}</h3>
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="electronic_container">
            <h2>应用场景</h2>
            <div class="electronic_content pzly yycj">
                <div class="item-1">
                    <div class="list">
                        <img :src="imgAllPath('yycj_01.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">01</div>
                            <div class="content">银企财务</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>电子回单</h2>
                                <ul>
                                    <li>转存/付款回单</li>
                                    <li>电子对账单</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <img :src="imgAllPath('yycj_02.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">04</div>
                            <div class="content">财务核算</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>记账凭证</h2>
                                <ul>
                                    <li>会计入账凭证</li>
                                    <li>报销申请单</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-1">
                    <div class="list">
                        <img :src="imgAllPath('yycj_03.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">02</div>
                            <div class="content">交通运输</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>客票凭证</h2>
                                <ul>
                                    <li>铁路客票</li>
                                    <li>航空运输行程单</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <img :src="imgAllPath('yycj_04.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">05</div>
                            <div class="content">进口出口</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>海关凭证</h2>
                                <ul>
                                    <li>海关专用缴纳书</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-1 item-3">
                    <div class="list">
                        <img :src="imgAllPath('yycj_05.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">03</div>
                            <div class="content">金融保险</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>保单凭证</h2>
                                <ul>
                                    <li>财险电子保单</li>
                                    <li>寿险电子保单</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <img :src="imgAllPath('yycj_06.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">06</div>
                            <div class="content">政府监管</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>财政凭证</h2>
                                <ul>
                                    <li>非税收入票据</li>
                                    <li>结算票据</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <img :src="imgAllPath('yycj_07.png')" alt />
                        <div class="mask_bj"></div>
                        <div class="mask">
                            <div class="index_num">07</div>
                            <div class="content">其他应用</div>
                        </div>
                        <div class="mask_hover">
                            <div class="content">
                                <h2>其他应用</h2>
                                <ul>
                                    <li>运营商业务凭证</li>
                                    <li>电子保函</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="electronic_container cpys_container">
            <h2>产品优势</h2>
            <div class="electronic_content pzly cpys">
                <div class="item" v-for="(item, index) in cpysList" :key="index">
                    <img :src="imgAllPath(item.img)" alt />
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div>
        <div class="electronic_container">
            <h2>市场优势及客户案例</h2>
            <div class="electronic_content anli">
                <img :src="imgAllPath('khal_bj.png')" alt />
                <div class="al_list">
                    <ul>
                        <li v-for="(item, index) in alList" :key="index">
                            <h2>{{ item.name }}</h2>
                            <p>{{ item.content }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="anli_container">
            <div class="anli_list">
                <img :src="imgAllPath(item)" alt v-for="(item, index) in alImgList" :key="index" />
            </div>
        </div>
        <customer-service></customer-service>
        <footer-nav></footer-nav>
    </div>
</template>

<script>
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
import electronicDec from "@comm/components/document-conversion/electronicDec";
import { getToken } from "@comm/utils/auth";
export default {
    components: { footerNav, customerService, headNav, electronicDec},
    name: "index",
    data() {
        let self = this;
        return {
            isPhone: localStorage.isPhone,
            sdkList: ['批量验真', '提取元数据', '提取XBRL附件'],
            pzlyList: [
                { img: 'pzly_01.png', name: '凭证阅览', content: '支持跨平台跨设备多终端阅览' },
                { img: 'pzly_02.png', name: '签章验证', content: '支持验证凭证签章的真伪，提供凭证签章批量验证' },
                { img: 'pzly_03.png', name: '结构化数据提取', content: '精准解析OFD凭证的结构化数据，并进行数据提取' },
                { img: 'pzly_04.png', name: 'XBRL服务', content: '支持生成XBRL附件，提取XBRL附件到指定位置，支持XBRL与JSON格式数据互转' },
                { img: 'pzly_05.png', name: '水印、注释应用', content: '支持凭证在使用中添加水印说明，条形码、归档章、图章等' }
            ],
            cpysList: [
                { img: 'cpys_01.png', name: '完善的产品功能', content: '提供电子凭证模板制作、生成加工、预览验证、解析利用、XBRL封装等全生命周期产品能力。' },
                { img: 'cpys_02.png', name: '极致的性能体验', content: '极简部署、快速集成，大大提升电子凭证业务生成效率，满足业务高并发、低延迟的性能要求。' },
                { img: 'cpys_03.png', name: '丰富的生态兼容', content: '全方位测试，多平台软件版本，信创、非信创软硬件平台的全面兼容。' },
                { img: 'cpys_04.png', name: '合规的标准认证', content: '符合OFD国家标准，满足财政电子凭证会计数据标准，具备可扩展商业报告语言(XBRL)软件认证证书及产品软著。' }
            ],
            pztxList: [
                { img: 'dzpztx_01.png', name: '数据可信', content: '天然支持国产密码' },
                { img: 'dzpztx_02.png', name: '一键验真', content: '签章互认，一键验真' },
                { img: 'dzpztx_03.png', name: '体积精简', content: 'XML+ZIP，超高压缩机制' },
                { img: 'dzpztx_04.png', name: '精准解析', content: '内嵌结构化数据，自动解析' },
                { img: 'dzpztx_05.png', name: '简单易用', content: '极简部署，简单易用' },
                { img: 'dzpztx_06.png', name: '降本增效', content: '降低成本，提升效率' },
                { img: 'dzpztx_07.png', name: '安全可靠', content: '自主可控技术，真实可靠' },
                { img: 'dzpztx_08.png', name: '创新应用', content: '先进版式技术，自主创新' }
            ],
            alList: [
                { name: '拥有广阔的OFD市场', content: '业内案例多、影响范围广的OFD版式软件厂商，在OFD行业深耕多年，匠心打造OFD电子凭证行业发展潮头，并持续打造行业标杆客户，引领行业发展新风向。' },
                { name: '完备的解决方案能力', content: '提供电子凭证全业务流程的版式软件功能，提供一对一、端到端的OFD电子凭证产品解决方案。' },
                { name: '成功的金融行业案例', content: 'OFD银行电子回单应用版式软件供应商，工商银行、光大银行、盛京银行、浙商银行等电子凭证会计标准试点单位。' }
            ],
            alImgList: ['khal_01.png', 'khal_02.png', 'khal_03.png', 'khal_04.png'],
            fwzcList: [
                { name: '模板设计及管理', content: '提供行业标准模板库，支持用户在线模板设计、上传已有的模板文件，对我的模板库进行统一管理。' },
                { name: '电子签章服务', content: '提供批量验章及调取使用电子签章的整体服务，支持集成三方的签章库。' },
                { name: '凭证生成服务', content: '极速精准的数据合成，加盖签章后，生成标准的OFD电子凭证。' },
                { name: '凭证预览', content: '提供在线阅览OFD电子凭证，支持跨平台、跨设备、多终端。' },
                { name: '凭证利用服务', content: '提取XBRL附件&XBRL与JSON格式互转，以及凭证文件格式转换。' },
                { name: '可视化监控服务', content: '提供可视化的服务端监控平台，对服务端的运行及任务情况一目了然。' }
            ],
            realIndex: 0,
            swiperOptions: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                loop: true, // 循环模式选项
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }, // 自动播放
                speed: 2000, // 切换速度
                effect: "slide", // 动画 fade cube slide coverflow flip
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                on: {
                    slideChange: () => {
                        self.realIndex = this.$refs.mySwiper.swiper.realIndex
                    }
                }
            },
            current: null,
            disabled: false,
            token: null,
        };
    },
    created() {
        this.token = getToken()
        document.title = "电子凭证";
        this.$store.commit("SET_ACTIVEMODEL", "1");
        this.$nextTick(() => {
			this.toLocal();
		});
    },
    watch: {
        $route(to, from) {
            this.$router.go(0);
        },
    },
    computed: {
        imgAllPath() {
            return function (img) {
                return require(`@comm/images/document-conversion/electronicDocuments/${img}`);
            };
        },
    },
    destroyed() {
		localStorage.setItem("toId", "");
	},
    methods: {
        toLocal() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
			}
		},
        getUserToken(data) {
            this.token = data.token
        },
        chooseIndex(index) {
            this.realIndex = index
            this.$refs.mySwiper.swiper.slideToLoop(this.realIndex, 100, true);
        },
        downLoadSdk() {
            window.open(localStorage.sdkLink, "_self");
        },
    }
};
</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
}
.modal_wrapper{
    width: 100%;
}
.dialog-footer {
            float: right;
            margin-top: 50px;
        }
.customDialog {
    .modal_wrapper {
        flex: 1;
        padding: 0 25px;

        .dialog-footer {
            float: right;
            margin-top: 50px;
        }
    }
}

.qz_icon {
    width: 24px;
    vertical-align: middle;
    margin-right: 6px;
}

.download_sdk {
    width: 100%;
    padding: 18px 0;
    background: url(../../comm/images/document-conversion/electronicDocuments/sdk_bj.png) 0 0 no-repeat;
    background-size: 100% 100%;
}

.electronic_content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    &.sdk {

        .el-button {
            width: auto;
            font-size: 16px !important;
            padding: 12px 34px !important;
            line-height: 28px;
        }

        ul {
            margin-left: 80px;
            display: flex;
            align-items: center;

            li {
                display: flex;
                align-items: center;
                font-size: 18px;
                color: #36425A;
                line-height: 25px;
                margin-right: 35px;

                span {
                    width: 42px;
                    height: 42px;
                    margin-right: 8px;
                }

                &:nth-child(1) span {
                    background: url(../../comm/images/document-conversion/electronicDocuments/sdk_01.png) 0 0 no-repeat;
                    background-size: 100%;
                }

                &:nth-child(2) span {
                    background: url(../../comm/images/document-conversion/electronicDocuments/sdk_02.png) 0 0 no-repeat;
                    background-size: 100%;
                }

                &:nth-child(3) span {
                    background: url(../../comm/images/document-conversion/electronicDocuments/sdk_03.png) 0 0 no-repeat;
                    background-size: 100%;
                }
            }
        }
    }

    &.electronic_content_reader {
        display: block;

        .file_operation {
            margin-top: 80px;
            width: 100%;
            display: flex;
            // justify-content: space-between;
            justify-content: flex-end;
            align-items: center;

            .el-button {
                height: 40px;
                line-height: 40px;
            }

            .el-button--default.is-disabled {
                border: 1px solid #DCDCDC !important;
                color: #fff !important;
                background-color: #DCDCDC !important;
            }

            .right_operation {
                .el-button+.el-button {
                    margin-left: 24px !important;
                }

                .el-button {
                    width: 120px;
                }
            }
        }

        .upload_btn {
            width: 120px;
            height: 40px;
            line-height: 40px;
            color: #fff !important;
            border-radius: 2px;
            background-color: #14A8F0 !important;
            font-size: 14px !important;
            text-align: center;

            &:hover {
                background-color: #008AD9 !important;
            }

            img {
                vertical-align: middle;
                width: 16px;
                height: 16px;
            }
        }

        .uploadBtn {
            border: 1px solid #14A8F0 !important;
            color: #fff !important;
            background-color: #14A8F0 !important;

            &:hover {
                background-color: #008AD9 !important;
                color: #fff !important;
            }
        }

        .uploader-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: normal;
            img {
                margin-right: 8px;
            }
        }

        .reader_wrapper {
            margin-top: 24px;
            border: 1px solid #ccc;

            .upload_wrapper {
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                height: 418px;
                font-size: 16px;

                p {
                    font-size: 14px;
                    margin-top: 24px;
                    color: #8B97AF;
                    line-height: 20px;
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .reader {
                .reader_header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 44px;
                    background: #f5f5f5;
                    padding: 0 15px 0 10px;
                    border-bottom: 1px solid #eaeaea;

                    .right {
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        >div:not(.more_box) {
                            padding: 5px 0;
                            margin-left: 15px;
                            font-size: 12px;
                            color: #36425A;
                            line-height: 17px;

                            img {
                                width: 24px;
                                height: 24px;
                            }

                            &:hover {
                                cursor: pointer;
                                // background: #e4e4e4;
                                border-radius: 2px;
                            }
                        }

                        .more_box {
                            position: absolute;
                            right: 15px;
                            top: 44px;

                            .qrcode_body {
                                display: flex;
                                justify-content: flex-start;
                                flex-direction: column;
                                align-items: center;
                                width: 139px;
                                height: 82px;
                                border-radius: 2px;
                                padding: 5px 0;
                                border: 1px solid #ccc;
                                background-color: #fff;

                                .list {
                                    height: 24px;
                                    padding: 0 23px;
                                    line-height: 24px;
                                    font-size: 12px;
                                    color: #333;
                                    width: 100%;
                                    cursor: pointer;

                                    &:hover {
                                        background: #f5f5f5;
                                    }
                                }
                            }
                        }
                    }

                    img {
                        width: 32px;
                        height: 32px;
                        vertical-align: middle;
                    }
                }

                .reader_content {
                    height: 100%;
                    background-color: #E7E7E7;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        height: 100%;
                    }
                }
            }
        }
    }
}

.electronic_container {
    padding: 80px 0;

    h2 {
        text-align: center;
        font-size: 32px;
        color: #242F44;
        line-height: 45px;
        margin-bottom: 64px;
    }

    &.cpys_container {
        background: rgba(247, 249, 252, .69);
    }

    &.fwzc_container {
        background: url(../../comm/images/document-conversion/electronicDocuments/fwzc_bj.png) 0 0 no-repeat;
        background-size: 100% 100%;
    }
}

.pzly {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
        width: 234px;
        height: 238px;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 23px 21px 29px 21px;

        &:hover {
            box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);
        }

        img {
            width: 64px;
            height: auto;
        }

        h3 {
            font-size: 20px;
            color: #36425A;
            line-height: 28px;
            margin: 23px 0 8px;
        }

        p {
            height: 68px;
            font-size: 14px;
            color: #8B97AF;
            line-height: 22px;
            text-align: center;
        }
    }
}

.cpys {
    .item {
        width: 276px;
        height: 236px;
        padding: 16px;
        align-items: flex-start;

        &:hover {
            box-shadow: none
        }

        h3 {
            margin: 16px 0 8px;
        }

        p {
            height: 88px;
            text-align: left;
        }
    }
}

.pztx {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .item {
        width: 282px;
        height: 136px;
        background: #FFFFFF;
        box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);
        padding: 36px 17px;
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: 24px;

        img {
            width: 65px;
            margin-right: 15px;
        }

        h3 {
            margin: 0 0 8px 0;
        }

        p {
            height: auto;
            text-align: left;
        }
    }
}

.yycj {
    align-items: flex-start;

    .item-1 {
        width: 340px;
        margin-right: 24px;

        .list {
            position: relative;
            border-radius: 8px;
            overflow: hidden;

            &:nth-child(1) {
                margin-bottom: 24px;
            }

            &:hover {
                .mask {
                    display: none;
                }

                .mask_hover {
                    display: block;
                }

                .mask_bj {
                    background: linear-gradient(180deg, rgba(123, 160, 223, 0.19) 0%, rgba(88, 127, 195, 0.65) 32%, #3D65AE 100%);
                    opacity: 0.75;
                }
            }

            img {
                width: 100%;
            }

            .mask_bj {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(180deg, rgba(46, 46, 46, 0.19) 0%, #555D6C 100%);
                opacity: 0.81;
            }

            .mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            .index_num {
                font-size: 78px;
                font-weight: 600;
                color: rgba(186, 189, 193, 0.2);
                line-height: 101px;
                // background: linear-gradient(180deg, rgba(186, 189, 193, 0.66) 0%, rgba(172, 194, 226, 0) 100%);
                // -webkit-background-clip: text;
                // -webkit-text-fill-color: transparent;
                position: absolute;
                bottom: 0;
                left: 10px;
            }

            .content {
                font-size: 20px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 28px;
                position: absolute;
                bottom: 22px;
                left: 24px;
            }

            .mask_hover {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                .content {
                    position: absolute;
                    bottom: 16px;
                    left: 24px;
                    width: 80%;

                    h2 {
                        font-size: 20px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 28px;
                        position: relative;
                        margin-bottom: 22px;
                        text-align: left;

                        &::after {
                            content: '';
                            width: 24px;
                            height: 2px;
                            background: #14A8F0;
                            position: absolute;
                            bottom: -13px;
                            left: 0;
                        }
                    }

                    ul {
                        padding-left: 16px;

                        li {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 28px;
                            list-style-type: disc;
                        }
                    }
                }
            }
        }
    }

    .item-3 {
        width: 472px;
        margin-right: 0;

        .list {
            &:nth-child(2) {
                margin-right: 19px;
            }

            &:nth-child(2),
            &:nth-child(3) {
                display: inline-block;
                width: 224px;
            }
        }
    }
}

.anli {
    position: relative;
    padding-left: 87px;
    display: block;

    &>img {
        position: absolute;
        top: 0;
        left: 0;
        width: 520px;
    }

    .al_list {
        width: 100%;
        background: linear-gradient(138deg, #F4FCFF 0%, #EFFAFF 100%);
        padding: 24px 32px;
        text-align: right;

        ul {
            display: inline-block;
            width: 594px;

            li {
                margin-bottom: 32px;

                &:last-child {
                    margin: 0;
                }

                h2 {
                    font-size: 20px;
                    font-weight: 600;
                    color: #36425A;
                    line-height: 28px;
                    margin-bottom: 16px;
                    text-align: left;
                }

                p {
                    height: 44px;
                    font-size: 14px;
                    color: #8B97AF;
                    line-height: 22px;
                    text-align: left;
                }
            }
        }
    }
}

.anli_container {
    padding: 25px 0 80px;
}

.anli_list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;

    img {
        width: 294px;
    }
}

.fwzc {
    display: flex;
    align-items: center;
    align-items: center;

    .left {
        width: 635px;
        margin-right: 79px;

        img {
            width: 100%;
        }
    }

    .right {
        flex: 1;

        ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            li {
                font-size: 20px;
                font-weight: 400;
                color: #8B97AF;
                line-height: 28px;
                padding: 24px;
                position: relative;
                cursor: pointer;

                span {
                    margin-right: 23px;
                }

                .num {
                    display: none;
                    font-size: 96px;
                    font-family: Helvetica;
                    color: rgba(175, 224, 251, 0.19);
                    line-height: 115px;
                    // background: linear-gradient(218deg, #51C8FC 0%, rgba(175, 224, 251, 0.19) 100%);
                    // -webkit-background-clip: text;
                    // -webkit-text-fill-color: transparent;
                    position: absolute;
                    top: 0;
                    right: 10px;
                    // opacity: .19;
                    font-weight: 600;
                }

                .hover_content {
                    display: none;

                    h2 {
                        font-size: 20px;
                        color: #14A8F0;
                        line-height: 28px;
                        margin-bottom: 18px;
                        text-align: left;
                    }

                    p {
                        font-size: 14px;
                        color: #8B97AF;
                        line-height: 22px;
                        font-weight: normal;
                    }
                }

                &.active {
                    width: 100%;
                    height: 138px;
                    background: #F0FAFF;
                    box-shadow: 0px 2px 14px 0px rgba(19, 167, 240, 0.2);

                    .name {
                        display: none;
                    }

                    .hover_content,
                    .num {
                        display: block;
                    }
                }
            }
        }
    }
}

 .el-dialog {
    .el-dialog__body {
        padding-bottom: 52px;
    }

    .modal_wrapper {
        display: inline-block;
        vertical-align: top;

        .state {
            margin: 24px auto 48px;
            display: flex;
            justify-content: flex-start;

            img {
                width: 42px;
                height: 42px;
            }

            .info {
                margin-left: 24px;

                .info_title {
                    font-size: 20px;
                    color: #36425A;
                }

                .subtitle {
                    margin-top: 8px;
                    font-size: 14px;
                    color: #666;
                }
            }
        }

        .signature,
        .seal {

            .signature_title,
            .seal_title {
                color: rgba(79, 93, 121, 0.5);
                margin-bottom: 16px;
            }

            .info {
                text-indent: 16px;

                >div {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 16px;

                    span {
                        &:first-child {
                            width: 115px;
                        }
                    }
                }
            }
        }
    }
}


</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/electronicCertificate.vue